"use client";

import ErrorScreen from "@/components/common/ErrorScreen";

export default function UserError({
  error,
  unstable_retry,
}: {
  error: Error & { digest?: string };
  unstable_retry: () => void;
}) {
  return (
    <ErrorScreen
      title="Halaman ini gagal dimuat"
      description="Ada kendala saat mengambil datamu. Progres belajar dan pembelianmu tidak terpengaruh."
      digest={error.digest}
      onRetry={unstable_retry}
      homeHref="/dashboard"
      homeLabel="Ke Dashboard"
    />
  );
}
